import { render, staticRenderFns } from "./handouts-list.vue?vue&type=template&id=2328d760&"
import script from "./handouts-list.vue?vue&type=script&lang=js&"
export * from "./handouts-list.vue?vue&type=script&lang=js&"
import style0 from "./handouts-list.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "handouts-list.vue"
export default component.exports